import { t } from "ttag";

import type { DisabledReason } from "@/features/products/models/types";
import type { Category } from "@/shared/domains";
import { CATEGORY_SLUG } from "@/shared/domains";

export const CATEGORY_COLOR = {
  [CATEGORY_SLUG.WEIGHT_LOSS]: "light-secondary",
  [CATEGORY_SLUG.HAIR_GROWTH]: "light-nutmeg",
  [CATEGORY_SLUG.MICRODOSING]: "light-tasman",
  [CATEGORY_SLUG.LONGEVITY]: "light-bismark",
  [CATEGORY_SLUG.TESTOSTERONE]: "light-merlot",
} as const;

export const GLP1_CATEGORIES: Category["slug"][] = [
  CATEGORY_SLUG.WEIGHT_LOSS,
  CATEGORY_SLUG.MICRODOSING,
] as const;

export const DISABLED_REASON = {
  ALREADY_HAS_SUBSCRIPTION: "already_has_subscription",
  NOT_ELIGIBLE: "not_eligible",
  ALREADY_HAS_SUBSCRIPTION_FOR_CATEGORY:
    "already_has_subscription_for_category",
  ALREADY_HAS_SUBSCRIPTION_FOR_VARIANT_PRODUCT:
    "already_has_subscription_for_variant_of_product",
  CANT_HAVE_PRODUCT_IN_CURRENT_STATE: "cant_have_product_in_current_state",
} as const;

export const getDisabledReasonLabel = (reason: DisabledReason["type"]) => {
  return {
    [DISABLED_REASON.ALREADY_HAS_SUBSCRIPTION]: t`Current subscription`,
    [DISABLED_REASON.NOT_ELIGIBLE]: t`Ineligible`,
    [DISABLED_REASON.ALREADY_HAS_SUBSCRIPTION_FOR_CATEGORY]: t`Current category`,
    [DISABLED_REASON.ALREADY_HAS_SUBSCRIPTION_FOR_VARIANT_PRODUCT]: t`Current product variant`,
    [DISABLED_REASON.CANT_HAVE_PRODUCT_IN_CURRENT_STATE]: t`Not currently available in your state`,
  }[reason];
};
